export interface LoginLink {
  email: string;
  code: string;
}

/**
 * Lien de l'e-mail de connexion : `/login#email=…&code=…` sur le site, transmis au jeu en
 * `/play/#login&email=…&code=…`. Le code voyage dans le fragment, que les serveurs ne voient jamais.
 */
export function parseLoginLink(hash: string): LoginLink | null {
  let fragment = hash.replace(/^#/, "");
  if (fragment.startsWith("login")) fragment = fragment.slice("login".length).replace(/^[&?]/, "");
  const params = new URLSearchParams(fragment);
  const email = params.get("email")?.trim().toLowerCase() ?? "";
  const code = (params.get("code") ?? "").replace(/\s+/g, "");
  if (!email.includes("@") || !/^\d{6}$/.test(code)) return null;
  return { email, code };
}

/** Lit le lien dans l'adresse, puis l'en efface : un rechargement ne le rejoue pas. */
export function takeLoginLink(): LoginLink | null {
  const link = parseLoginLink(window.location.hash);
  if (window.location.hash.startsWith("#login") || link) {
    window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
  }
  return link;
}
